module.exports = __webpack_public_path__ + "static/adjustable-base-classic-c21e8004682ba101098788cd7f5aa880.jpeg";